import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import RideFare from './RideFare';
import messages from '../../../../locale/messages';

function action({ store, intl }) {
  const title = intl.formatMessage(messages.manageRideFare);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  return {
    title,
    component: (
      <AdminLayout>
        <RideFare title={title} />
      </AdminLayout>
    ),
  };
}

export default action;
